import request from "../../tools/http";
import Types from "../../../typings/interface";
export default {
  /**
   * 获取banner图
   * @param data
   * @returns
   */
  getBannerList<T>(
    params: Types.Http.IGoodsTypeReq
  ): Promise<Types.Http.IResponseData<T>> {
    return request({
      method: "get",
      url: "/common/banner",
      params
    });
  },

  /**
   * 获取商品列表
   * @param params
   * @returns
   */
  getGoodsList<T>(
    params: Types.Http.IGoodsTypeReq
  ): Promise<Types.Http.IResponseData<T>> {
    return request({
      method: "get",
      url: "/common/goodsLists",
      params
    });
  },

  /**
   * 获取商品详情
   * @param params
   * @returns
   */
  getGoodsDetail<T>(
    params: Types.Http.IGoodsDetailReq
  ): Promise<Types.Http.IResponseData<T>> {
    return request({
      method: "get",
      url: "/common/goodsSpecLists",
      params
    });
  }
};
